module.exports = __webpack_public_path__ + "static/media/iconnn.bead731d.png";